// Code generated by pkg/router_helper/make_api.go, DO NOT EDIT.

import { fetchApi } from '../fetchApi'

import * as Types from './type'

export const infoApi = {
  check2fa: {
    method: 'post',
    path: '/api-bff/user/info/check2fa',
    fnMeta: {
      parameters: [],
      returnType: {
        kind: '',
      },
    },
    flag: null,
  },
}

export function check2fa(...args: any): Promise<Types.UserTwoFactorAuthRespDTO> {
  return fetchApi(infoApi.check2fa as any, ...args) as Promise<Types.UserTwoFactorAuthRespDTO>
}
